// if (typeof wp.data != 'undefined' && typeof wp.blocks != 'undefined') {

window.buildVisualOptions = function( options ) {

// {
//   key: 'strip-style',
//   panel: 'Strip Style',
//   prop: 'themeStripStyle',
//   class: 'strip-style',
//   blocks: [
//     'core/button',
//     'core/heading',
//     'core/quote',
//   ],
// }

return (function (wp, options) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;
  var Button = wp.components.Button;
  var ButtonGroup = wp.components.ButtonGroup;
  var Icon = wp.components.Icon;

  var allowedBlocks = options.blocks;

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        [options.prop]: {
          type: 'string',
          default: ''
        }
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      let values = options.values;
      let controls = [];

      for (let value in values) {
        let src = values[value];
        let isSVG = (src.indexOf('<svg') > -1);

        controls.push(
          el(Button, {
              text: value,
              isPressed: (props.attributes[options.prop] == value),
              className: 'value-' + value,
              onClick: () => props.setAttributes({ [options.prop]: value }),
            },
            isSVG ?
              wp.element.RawHTML( { children: src } ) :
              el('img', {
                src: THEME_URI + '/' + src,
                height: 100,
                width: 100,
              }),
          )
        );
      }

      controls = el(InspectorControls, {},
        el(PanelBody, {
          title: options.panel,
          initialOpen: true
        },
          el(PanelRow, {},
            el(
              ...[ButtonGroup, {
                className: 'visual_options visual_options-' + [options.class]
              }].concat(controls)
            ), // button group
          ),
          el(PanelRow, {},
            el(Button, {
              text: 'Clear',
              isPressed: false,
              isLink: true,
              onClick: () => props.setAttributes({ [options.prop]: '' }),
            })
          ),
        )
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (typeof props.attributes[options.prop] !== 'undefined' && allowedBlocks.includes(props.name)) {

        if (typeof props.className === 'undefined') {
          props.className = '';
        }

        let values = options.values;

        for (let value in values) {
          let className = options.class + '-' + value;
          props.className = props.className.replace(`/${className}/g`, '');
        }

        if (props.attributes[options.prop] && props.attributes[options.prop] != 'default') {
          let className = options.class + '-' + props.attributes[options.prop];
          props.className += ' ' + className;
        }
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (typeof attributes[options.prop] !== 'undefined' && allowedBlocks.includes(blockType.name)) {

      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      let values = options.values;

      for (let value in values) {
        let className = options.class + '-' + value;
        extraProps.className = extraProps.className.replace(`/${className}/g`, '');
      }

      if (attributes[options.prop] && attributes[options.prop] != 'default') {
        let className = options.class + '-' + attributes[options.prop];
        extraProps.className += ' ' + className;
      }
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/visual-options-attributes-' + options.key,
    addAttributes
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/visual-options-controls-' + options.key,
    withInspectorControls
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/visual-options-class-admin-' + options.key,
    withCustomClassName
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/visual-options-class-' + options.key,
    applyExtraClass
  );
})(window.wp, options);

};

// }